<template>
  <div>
    <v-card class="pa-5 elevation-hb">
      <v-row align="center" justify="center">
        <v-col cols="5">
          <h3><v-icon>mdi-medal-outline</v-icon> Bonificações dos Sellers</h3>
        </v-col>
        <v-col cols="2">
          <TheDatePicker v-model="date" @ok="loadContent()"
        /></v-col>
        <v-col cols="">
          <TheSearchInput v-model="search" />
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn 
            depressed 
            color="primary" 
            class="text-center mr-1"
            :disabled="!objects.length"
            :dark="objects.length" 
            @click="downloadCSV()" 
            block
          >
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV
          </v-btn>
        </v-col>
      </v-row>

      <div v-if="dateSearch">
        <v-alert
          border="left"
          color="indigo darken-4"
          dark
          class="my-5 px-5 py-2 elevation-hb"
          transition="scroll-x-transition"
        >
          <v-row class="ma-0 pa-0 align-center">
            <v-col cols="11" class="ma-0 pa-0">{{ infoMessage }}</v-col>
            <v-col cols="1" class="ma-0 pa-0 text-right">
              <v-btn
                fab
                small
                color="indigo darken-3"
                dark
                depressed
                @click="clearDate()"
              >
                <v-icon x-small>mdi-minus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </div>

      <v-divider class="my-3"></v-divider>
      <v-data-table
        :headers="headers"
        :items="objects"
        :search="search"
        :loading="loading"
      >
        <template v-slot:[`item.value`]="{ item }">
          {{ item.value | formatMoney }}
        </template>
        <template v-slot:[`item.updatedAt`]="{ item }">
          {{ item.updatedAt | formatFullDate }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon @click="openHistory(item)" class="mr-1">mdi-history</v-icon>
          <v-icon @click="openEdit(item)" class="mr-1"
            >mdi-pencil-box-outline</v-icon
          >
        </template>
      </v-data-table>
    </v-card>

    <TheDialog
      title="Bonificações"
      icon="mdi-medal-outline"
      v-model="dialogEdit"
      width="600px"
    >
      <template>
        <div v-if="object">
          <v-form v-model="valid" ref="form">
            <h3 class="mb-2">
              Alterar Bonificações para {{ object.sellerId }}
            </h3>

            <b>Valor</b>
            <v-text-field
              v-mask="['R$ ##,##', 'R$ ###,##', 'R$ ####,##', 'R$ #####,##']"
              :rules="[(v) => !!v || 'Campo obrigatório']"
              outlined
              v-model="object.value"
            ></v-text-field>

            <b>Tipo</b>
            <v-select
              :items="types"
              :rules="[(v) => !!v || 'Campo obrigatório']"
              clearable
              item-text="text"
              item-value="value"
              outlined
              v-model="object.type"
            ></v-select>

            <b>Observação</b>
            <v-text-field outlined v-model="object.observation"></v-text-field>
          </v-form>
        </div>
      </template>
      <template v-slot:actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary text--white" depressed @click="save()"
          >Salvar</v-btn
        >
      </template>
    </TheDialog>

    <TheDialog
      title="Histórico de Bonificações"
      icon="mdi-medal-outline"
      v-model="dialogHistory"
      overlay-color="white"
      width="1200px"
    >
      <template>
        <v-simple-table v-if="object">
          <thead>
            <tr>
              <th width="10%">Tipo</th>
              <th width="30%">Valor</th>
              <th width="30%">Observação</th>
              <th width="30%">Data</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, i) in history" :key="i">
              <td>{{ item.type }}</td>
              <td>{{ item.value | formatMoney }}</td>
              <td>{{ item.observation }}</td>
              <td>{{ item.updatedAt | formatFullDate }}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <th>Saldo Total</th>
              <th colspan="3" class="text-right">
                {{ object.value | formatMoney }}
              </th>
            </tr>
          </tfoot>
        </v-simple-table>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { mask } from 'vue-the-mask'
import TheDialog from '@/components/TheDialog'
import TheSearchInput from '@/components/TheSearchInput'
import TheDatePicker from '@/components/TheDatePicker'

export default {
  components: {
    TheDialog,
    TheSearchInput,
    TheDatePicker,
  },
  directives: { mask },
  data: () => ({
    search: null,
    object: null,
    objects: [],
    dateSearch: false,
    date: [],
    headers: [
      { text: 'Seller', value: 'sellerId' },
      { text: 'Valor Atual', value: 'value' },
      { text: 'Ultíma Alteração', value: 'updatedAt' },
      { text: 'Ações', value: 'action', width: '10%' },
    ],
    types: [
      { text: 'Entrada', value: 'Entrada' },
      { text: 'Saída', value: 'Saída' },
    ],
    loading: false,
    history: null,
    dialogHistory: false,
    dialogEdit: false,
    valid: false,
  }),
  methods: {
    loadContent() {
      this.loading = true
      const date = this.date
      const url = `${baseApiUrl}/bonus`
      axios
        .get(url, { params: { date } })
        .then((res) => {
          if (this.date.length === 1) {
            this.infoMessage = `Filtrando por data: ${this.$options.filters.formatDate(
              this.date[0]
            )}.`
          } else if (this.date.length > 1) {
            this.infoMessage = `Filtrando por data: ${this.$options.filters.formatDate(
              this.date[0]
            )} à ${this.$options.filters.formatDate(this.date[1])}.`
          }
          this.objects = res.data
          this.loading = false
          if (this.date.length > 0) {
            this.dateSearch = true
          } else {
            this.dateSearch = false
          }
        })
        .catch(showError)
    },
    loadHistory(id) {
      const url = `${baseApiUrl}/bonus/${id}`
      this.loading = true
      axios
        .get(url)
        .then((res) => {
          this.loading = false
          this.history = res.data
          this.dialogHistory = true
        })
        .catch(showError)
    },
    loadData() {},
    clearDate() {
      this.date = []
      this.loadContent()
    },
    openEdit(item) {
      this.object = {}
      this.object.sellerId = item.sellerId
      this.dialogEdit = true
      this.$refs.form.resetValidation()
    },
    openHistory(item) {
      this.object = item
      this.loadHistory(item.sellerId)
    },
    save() {
      this.$refs.form.validate()
      if (!this.valid) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text:
            'Hm, nem todos os campos estão preenchidos, você pode verificar por favor?',
          button: 'Ok!',
        })
        return false
      }
      const url = `${baseApiUrl}/bonus`
      const obj = {
        sellerId: this.object.sellerId,
        value: this.object.value,
        type: this.object.type,
        observation: this.object.observation,
      }

      obj.value = obj.value.replace('R$ ', '').replace(',', '')
      if (this.object.type === 'sub') {
        obj.value = '-' + obj.value
      }

      this.loading = true
      axios
        .post(url, obj)
        .then(() => {
          this.loading = false
          this.dialogEdit = false
          this.$refs.form.reset()
          this.loadContent()
        })
        .catch(showError)
    },
    downloadCSV() {
      const data = this.objects
      const fileName = 'Bonificacao-dos-sellers'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ','
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },
  mounted() {
    this.loadContent()
  },
}
</script>

<style></style>
